import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class ApiUrl extends React.Component {
    static propTypes = {
        theme: PropTypes.object
    }
    state  = {
        wms: null,
        wfs: null,
        wms_secure: null,
        title: null
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.title !== this.props.theme.attribution.Title) {
            this.setState({title: this.props.theme.attribution.Title});
            this.setState({wms: "https://kartat.sweco.fi/raster/" + this.props.theme.name + "/ows"})
            this.setState({wfs: "https://kartat.sweco.fi/geoserver/" + this.props.theme.name + "/ows"})
            this.setState({wms_secure: "https://kartat.sweco.fi/secureraster/" + this.props.theme.name + "/ows"})
        }
    };
    render() {
        return (
            <div>
                <h3>Rajapinnat ({this.state.title})</h3>
                <p>Kaikki rajapinnat eivät ole oletuksena käytössä. Jos sisältöä puuttuu, otathan yhteyden ylläpitäjään.</p>
                <p>
                    WMS (avoin): <a href={this.state.wms + "?REQUEST=GetCapabilities&SERVICE=WMS"} target="_blank">{this.state.wms}</a><br/>
                    WFS (avoin): <a href={this.state.wfs + "?REQUEST=GetCapabilities&SERVICE=WFS"} target="_blank">{this.state.wfs}</a>
                </p>
                <p>
                    WMS (salattu, tunnus sama kuin selainversioon): <a href={this.state.wms_secure + "?REQUEST=GetCapabilities&SERVICE=WMS"} target="_blank">{this.state.wms_secure}</a><br/>
                </p>
            </div>
        );
    };
}

const selector = (state) => ({
    theme: state.theme.current
});

export default connect(selector)(ApiUrl);